import { callApi } from '../../utils/apiCaller'
import { SCHOOL_PAYMENT_SERVICE_CHARGES_PATH } from '../routes'

export const fetchPaymentServiceCharges = () => {
  return callApi(`${SCHOOL_PAYMENT_SERVICE_CHARGES_PATH}`, {
    method: 'get',
  })
}
